import { useEffect, useState } from 'react';
import { Container, Row, Col, Card, Form, Button } from 'react-bootstrap';
import Logo from './Pro2.jpg'; // Muista vaihtaa polku logoosi
import { Navbar, Nav } from 'react-bootstrap';
import { VscFeedback, VscSignOut } from "react-icons/vsc";
import { Tabs, Tab } from 'react-bootstrap';

const ConAdd = ({ lan, kon, t, g }) => {
    const [konsultit, setKonsultit] = useState([]); // Konsultit taulukko
    const [konsultit2, setKonsulttiLista] = useState(kon);
    const [nimi, setNimi] = useState(''); // Nimi kenttä
    const [group, setGroup] = useState(g); // Group kenttä
    const [email, setEmail] = useState(''); // Email kenttä
    const [salasana, setSalasana] = useState(''); // Salasana kenttä
    const [salasanaVahvistus, setSalasanaVahvistus] = useState(''); // Vahvistuskenttä
    const [isLoading, setIsLoading] = useState(false);
    const [valittuRooli, setValittuRooli] = useState('konsultti');
    const [tcg, setTcg] = useState(t);
    

    useEffect(() => {
        if (group === "") {
            const currentUrl = window.location.href;
            const parsedUrl = new URL(currentUrl);
            const pathParts = parsedUrl.pathname.split('/');
            if (pathParts.length > 1) {
                setGroup(pathParts[1]); // tallennetaan "tcg" tilaan
            }
        }
    
    }, [group]);

    useEffect(() => {
       console.log(valittuRooli);
    }, [valittuRooli]);

    //nappi josta pois
    function homepage(){
      sessionStorage.clear(); // Tyhjennä kaikki sessionStorage-arvot
        window.location.reload();
      }

    // Tallenna uusi konsultti
    const tallenna = (e) => {
        e.preventDefault();
        if (salasana !== salasanaVahvistus) {
            alert("Salasanat eivät täsmää!");
            return;
        }

        const uusiKonsultti = {
            nimi,
            email,
            salasana,
        };

        setKonsultit([...konsultit, uusiKonsultti]);
        setNimi('');
        setEmail('');
        setSalasana('');
        setSalasanaVahvistus('');
    };

    const saveCons = async (event) => {
      event.preventDefault();
      if (salasana !== salasanaVahvistus) {
        alert("Salasanat eivät täsmää!");
        return;
      }

      setIsLoading(true);

    const url = valittuRooli === 'admin'
          ? 'https://us-central1-tcgai-c07e9.cloudfunctions.net/api/saveAdmin'
          : 'https://us-central1-tcgai-c07e9.cloudfunctions.net/api/saveConsults';

        fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            email: email,
            pass: salasana,
            id: group,
            name: nimi,
            rooli: valittuRooli,
          }),
        })
          .then((response) => {
            if (!response.ok) {
              throw new Error('Verkkopyyntö epäonnistui');
            }
            // Jos kyseessä on admin, oletetaan että ei tule JSON-vastausta
            if (valittuRooli === 'admin') return null;
            return response.json();
          })
          .then((data) => {
            setIsLoading(false);

            if (valittuRooli !== 'admin') {
              const temp = ["Ei konsulttia"];
              if (Array.isArray(data) && data.length > 0) {
                setKonsulttiLista(data);
              } else {
                setKonsulttiLista(temp);
              }
            }

            setNimi('');
            setSalasana('');
            setSalasanaVahvistus('');
            setEmail('');
          })
          .catch((error) => {
            setIsLoading(false);
            console.error(error);
          });

        }

    const lomakeSisalto = (rooli) => (
  <Form onSubmit={tallenna}>
    <Form.Group>
      <Form.Label htmlFor={`nimi-${rooli}`}>Nimi</Form.Label>
      <Form.Control
        id={`nimi-${rooli}`}
        type="text"
        value={nimi}
        placeholder={rooli === 'admin' ? 'Adminin tunnus' : 'Konsultin nimi'}
        onChange={(e) => setNimi(e.target.value)}
        required
      />
      <Form.Label htmlFor={`email-${rooli}`} style={{ paddingTop: "1vh" }}>Email</Form.Label>
      <Form.Control
        id={`email-${rooli}`}
        type="email"
        value={email}
        placeholder={rooli === 'admin' ? 'Adminin sähköposti' : 'Konsultin sähköposti'}
        onChange={(e) => setEmail(e.target.value)}
        required
      />
      <Form.Label htmlFor={`salasana-${rooli}`} style={{ paddingTop: "1vh" }}>Salasana</Form.Label>
      <Form.Control
        id={`salasana-${rooli}`}
        type="password"
        value={salasana}
        placeholder="Syötä salasana"
        onChange={(e) => setSalasana(e.target.value)}
        required
      />
      <Form.Label htmlFor={`salasanaVahvistus-${rooli}`} style={{ paddingTop: "1vh" }}>Vahvista salasana</Form.Label>
      <Form.Control
        id={`salasanaVahvistus-${rooli}`}
        type="password"
        value={salasanaVahvistus}
        placeholder="Syötä salasana uudelleen"
        onChange={(e) => setSalasanaVahvistus(e.target.value)}
        required
      />
    </Form.Group>
    <div style={{ textAlign: "center", marginTop: "4vh", justifyContent: "center" }}>
      <Button
        className="SignIn"
        variant="primary"
        type="button"
        style={{ width: "60%", marginLeft: "0%" }}
        onClick={(e) => saveCons(e)}
        >
        {rooli === 'admin' ? 'Luo admin-tunnukset' : 'Lisää konsultti'}
        </Button>
    </div>
  </Form>
);


    return (
        <div>
            {/* Navigation Icon Container */}
            <div className="TopNavIcon">
                <Nav.Link onClick={() => homepage()} className="d-none d-md-block">
                    <VscSignOut style={{ fontSize: "1.9em" }} />
                </Nav.Link>
            </div>
    
            <Container style={{ padding: "10px", height: "95vh" }}>
                <img className="FormLogo" src={Logo} style={{ height: "5vh", marginTop: "1vh" }} alt="Logo" />
                <h1 className="FormTitle" style={{ fontSize: "1.95em", marginBottom: "2vh" }}>Konsultti-lista</h1>
                <Row className="justify-content-start" style={{ width: "100%", height: "70vh" }}>
                    <Col md={4} style={{ overflowY: "auto", height: "100%" }}>
                        <ul>
                            {konsultit2.map((konsultti, index) => {
                                if (konsultti === "") return null;
                                return <li key={index}>{konsultti}</li>;
                            })}
                            </ul>
                    </Col>
                    
                    <Col md={5} style={{ display: "flex", justifyContent: "center" }}>
                        <Card className="Card" style={{ width: "100%", height: "100%", margin: "auto" }}>
                            <Card.Body style={{ display: "flex", flexDirection: "column", justifyContent: "center", height: "100%" }}>
                                <Tabs
                                    activeKey={valittuRooli}
                                    onSelect={(k) => setValittuRooli(k)}
                                    className="mb-3"
                                    >
                                    <Tab eventKey="konsultti" title="Konsultti">
                                        {lomakeSisalto('konsultti')}
                                    </Tab>
                                    {tcg && (
                                        <Tab eventKey="admin" title="Admin">
                                        {lomakeSisalto('admin')}
                                        </Tab>
                                    )}
                                    </Tabs>
                            </Card.Body>
                            </Card>
                    </Col>
                </Row>
            </Container>
        </div>
    );
    
};

export default ConAdd;
